import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';
import retry from '../../retry';
import PrivateRoute from '../../components/PrivateRoute';

const ComplementaryActivityListPage = lazy(() =>
  retry(() => import('./ComplementaryActivityListPage'))
);
const ComplementaryActivitiesForm = lazy(() =>
  retry(() => import('./ComplementaryActivitiesForm'))
);

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/atividades-complementares"
      component={ComplementaryActivityListPage}
    />
    <PrivateRoute
      exact
      path="/atividades-complementares/new"
      component={ComplementaryActivitiesForm}
    />
    <PrivateRoute
      exact
      path="/atividades-complementares/:id/edit"
      component={ComplementaryActivitiesForm}
    />
  </Switch>
);
